const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'mainImage',
      label: 'Zdjęcie główne',
      column: 1,
      type: 'file',
      single: true
    },
    {
      name: 'images',
      label: 'Zdjęcia',
      column: 1,
      type: 'file',
    },
  ],
};

export default fields;
